import {Litepicker} from 'litepicker';
import {loadReplyBodies} from './inbox_reply_body';

const MAX_FOLLOW_UP_MONTHS = 18;

function csrfToken(): string {
  return $("meta[name='csrf-token']").attr('content') || '';
}

function post(url: string, data: any, success: (response: any) => void, failed?: () => void): void {
  $.ajax({
    url,
    method: 'POST',
    data,
    headers: {'X-CSRF-Token': csrfToken()},
    success,
    error: (xhr) => {
      alert((xhr.responseJSON && xhr.responseJSON.error) || 'Something went wrong. Please try again.');
      if (failed) failed();
    },
  });
}

function isoDate(date: Date): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

// ---- segment filter -------------------------------------------------------

function initSegmentFilter(): void {
  $(document)
    .off('click.todoSeg')
    .on('click.todoSeg', '#todo-seg button', function () {
      const cat = String($(this).data('cat'));
      $('#todo-seg button').removeClass('active').attr('aria-selected', 'false');
      $(this).addClass('active').attr('aria-selected', 'true');

      // `.not()` keeps the filter from hiding its own buttons, which also carry data-cat.
      $('.todo-page [data-cat]')
        .not('#todo-seg [data-cat]')
        .each(function () {
          const $el = $(this);
          const own = String($el.data('cat')) === cat;
          $el.toggle($el.hasClass('todo-cat-empty') ? own : cat === 'all' || own);
        });
    });
}

// ---- load more ------------------------------------------------------------

function initLoadMore(): void {
  $(document)
    .off('click.todoMore')
    .on('click.todoMore', '[data-todo-more]', function (e) {
      e.preventDefault();
      e.stopPropagation();

      const $btn = $(this);
      if ($btn.prop('disabled')) return;

      const $footer = $btn.closest('.todo-more');
      const label = $btn.text();
      $btn.prop('disabled', true).text('Loading…');

      $.get(String($btn.data('url')))
        .done((html: string) => $footer.replaceWith(html))
        .fail(() => {
          $btn.prop('disabled', false).text(label);
          alert('Could not load more items. Please try again.');
        });
    });
}

// ---- date picker ----------------------------------------------------------

// Follow-ups move to tomorrow at the earliest; call tasks may move to today, so an overdue call can
// be brought back to today.
function openPicker($anchor: JQuery<HTMLElement>, onPick: (date: string) => void, minDays = 1): void {
  const input = document.getElementById('todo-reschedule-date') as HTMLInputElement | null;
  if (!input) return;

  // Times must be zeroed: litepicker compares the bound against each day at 00:00, so a minDate
  // carrying the current clock time locks out the first legal day.
  const minDate = new Date();
  minDate.setDate(minDate.getDate() + minDays);
  minDate.setHours(0, 0, 0, 0);
  const maxDate = new Date();
  maxDate.setMonth(maxDate.getMonth() + MAX_FOLLOW_UP_MONTHS);
  maxDate.setHours(23, 59, 59, 999);

  // Rebuilt each time: the anchor moves between rows and the modal footer.
  const picker = new Litepicker({
    element: input,
    singleMode: true,
    minDate,
    maxDate,
    format: 'YYYY-MM-DD',
    autoApply: true,
  });

  picker.on('selected', (date: any) => {
    onPick(isoDate(date.dateInstance ? date.dateInstance : date));
    picker.destroy();
  });
  picker.on('hide', () => picker.destroy());
  picker.show($anchor.get(0) as HTMLElement);
}

// ---- call tasks -----------------------------------------------------------

// PATCH with the day only; the server keeps the task's time of day and refuses a time already past.
function initCallTasks(): void {
  $(document)
    .off('click.todoCallPush')
    .on('click.todoCallPush', '.todo-call-push', function (e) {
      e.stopPropagation();
      const $row = $(this).closest('.todo-row');
      openPicker($(this), (date) => {
        $.ajax({
          url: String($row.data('task-url')),
          method: 'PATCH',
          contentType: 'application/json',
          data: JSON.stringify({task: {due_on: date}}),
          headers: {'X-CSRF-Token': csrfToken(), Accept: 'application/json'},
          success: () => window.location.reload(),
          error: (xhr) => {
            const errors = xhr.responseJSON && xhr.responseJSON.errors;
            const fallback = xhr.status === 404
              ? 'This task was completed or deleted elsewhere. The list will refresh.'
              : 'This task could not be rescheduled. Please try again.';
            alert((errors && errors[0]) || fallback);
            // a closed or removed task is gone: reload so the row goes too
            if (xhr.status === 404 || xhr.status === 403) window.location.reload();
          },
        });
      }, 0);
    });
}

// /todo?cat=calls (the call session's done screen) opens on that tab; /todo#cs also scrolls to it.
function openRequestedTab(): void {
  const hash = window.location.hash.replace('#', '');
  const cat = new URLSearchParams(window.location.search).get('cat') || hash;
  if (!cat) return;
  const $chip = $(`#todo-seg button[data-cat="${CSS.escape(cat)}"]`);
  if (!$chip.length) return;
  $chip.trigger('click');
  if (hash) document.getElementById(`todo-sec-${cat}`)?.scrollIntoView({block: 'start'});
}

// ---- customer success tasks -----------------------------------------------

function initCsTasks(): void {
  $(document)
    .off('click.todoCsDone')
    .on('click.todoCsDone', '.todo-cs-done', function (e) {
      e.preventDefault();
      e.stopPropagation();
      const $btn = $(this);
      const $row = $btn.closest('.todo-row');
      const done = $row.hasClass('done');
      $btn.prop('disabled', true);
      $.ajax({
        url: '/customer_success/change_status_stask',
        method: 'PATCH',
        data: {id: $row.data('cs-task-id'), status: done ? 'NOT_STARTED' : 'COMPLETED'},
        headers: {'X-CSRF-Token': csrfToken()},
        success: () => {
          $row.toggleClass('done', !done);
          $btn.contents().last().replaceWith(done ? 'Done' : 'Reopen');
        },
        error: () => alert("Couldn't update the HubSpot task. Please try again."),
        complete: () => $btn.prop('disabled', false),
      });
    });
}

// ---- follow-up approval ---------------------------------------------------

function initApproval(): void {
  const $modal = $('#todo-approval');
  if (!$modal.length) return;

  // The row whose follow-up is currently open in the modal.
  let $current: JQuery<HTMLElement> | null = null;

  const $subject = $modal.find('.todo-approval-subject');
  const $body = $modal.find('.todo-approval-text');

  // Summernote is initialised globally on page load. Fall back to the raw textarea if it is not up
  // yet, so the modal degrades to a plain field rather than breaking.
  const editorReady = () => $body.next('.note-editor').length > 0;

  const readBody = (): string =>
    editorReady() ? String($body.summernote('code') || '') : String($body.val() || '');

  const writeBody = (value: string): void => {
    if (editorReady()) {
      $body.summernote('code', value);
    } else {
      $body.val(value);
    }
  };

  // Stored drafts arrive as HTML from the Inbox (AI drafts and the compose box both produce markup),
  // but a draft written on the Candidates page can be plain text — whose newlines would collapse if
  // handed to an HTML editor.
  const asHtml = (value: string): string =>
    /<[a-z][\s\S]*>/i.test(value) ? value : value.replace(/\n/g, '<br>');

  // Summernote rewrites the markup it is given, so a raw comparison against the stored draft reports
  // "edited" the moment the modal opens. Capture what the editor itself considers the starting
  // point — the same trick summernote.ts uses in its onFocus callback.
  let baselineBody = '';
  let baselineSubject = '';

  function openModal($row: JQuery<HTMLElement>): void {
    $current = $row;

    $modal.find('.todo-approval-name').text(String($row.data('name') || ''));
    $modal.find('.todo-approval-campaign').text(String($row.data('campaign') || ''));
    $modal.find('.todo-approval-date').text(String($row.data('date') || ''));
    $subject.val(String($row.data('draft-subject') || ''));
    writeBody(asHtml(String($row.data('draft-body') || '')));
    baselineSubject = String($subject.val());
    baselineBody = readBody();

    const profileUrl = $row.data('profile-url');
    $modal
      .find('.todo-approval-profile')
      .attr('data-url', profileUrl ? String(profileUrl) : null as any)
      .prop('hidden', !profileUrl);

    // Fetched on open rather than inlined into every row, so full email bodies are not embedded in
    // the list page. The response is the same partial the reply drawer renders.
    const $thread = $modal.find('.todo-approval-thread').html('<div class="todo-approval-loading">Loading…</div>');
    $.get(String($row.data('thread-url')))
      .done((html: string) => {
        const $timeline = $('<div>').append(html).find('.inbox-timeline');
        // The Inbox thread ends with a card previewing this same pending follow-up, complete with
        // its own send/remove buttons. In this modal the draft is already shown — and editable —
        // just below, so that card would be a confusing duplicate.
        $timeline.find('.scheduled-note').remove();
        const timeline = $timeline.html();
        $thread.html(timeline || '<div class="todo-approval-loading">No earlier messages.</div>');
        loadReplyBodies($thread);
      })
      .fail(() => $thread.html('<div class="todo-approval-loading">Could not load the conversation.</div>'));

    $modal.prop('hidden', false);
  }

  function closeModal(): void {
    $modal.prop('hidden', true);
    $current = null;
  }

  function isDirty(): boolean {
    if (!$current) return false;
    return String($subject.val()) !== baselineSubject || readBody() !== baselineBody;
  }

  // send_inbox_follow_up sends the *stored* draft and ignores the request body, so an edited
  // textarea has to be persisted first or the edit is silently discarded.
  //
  // schedule_inbox_follow_up rejects any date <= now, and a due follow-up's date is by definition in
  // the past — so re-posting its own date always 422s. Nudge it a minute into the future instead;
  // send_inbox_follow_up only checks that a schedule is present, not that it is due.
  function saveIfDirty(done: () => void, failed?: () => void): void {
    if (!$current || !isDirty()) return done();

    const soon = new Date(Date.now() + 60 * 1000);
    post(
      String($current.data('schedule-url')),
      {
        follow_up: {
          scheduled_at: soon.toISOString(),
          subject: String($subject.val()),
          body: readBody(),
        },
      },
      () => done(),
      failed
    );
  }

  function reschedule($row: JQuery<HTMLElement>, date: string, then?: () => void): void {
    // schedule_inbox_follow_up overwrites subject and body, so omitting them would blank the draft.
    const subject = $current && $current.is($row) ? String($subject.val()) : String($row.data('draft-subject') || '');
    const body = $current && $current.is($row) ? readBody() : String($row.data('draft-body') || '');

    post(String($row.data('schedule-url')), {follow_up: {scheduled_at: date, subject, body}}, () => {
      if (then) then();
      window.location.reload();
    });
  }

  $(document)
    .off('click.todoFuReview')
    .on('click.todoFuReview', '.todo-fu-review', function (e) {
      e.stopPropagation();
      openModal($(this).closest('.todo-row'));
    });

  $(document)
    .off('click.todoFuPush')
    .on('click.todoFuPush', '.todo-fu-push', function (e) {
      e.stopPropagation();
      const $row = $(this).closest('.todo-row');
      openPicker($(this), (date) => reschedule($row, date));
    });

  $modal
    .off('click.todoApproval')
    .on('click.todoApproval', '.todo-approval-x', closeModal)
    .on('click.todoApproval', '.todo-approval-send', function () {
      if (!$current) return;
      // send_inbox_follow_up checks the schedule and sends without a lock, so a second click while
      // the first request is in flight sends the follow-up twice. Stay disabled on success: the page reloads.
      const $button = $(this);
      if ($button.prop('disabled')) return;
      if (!window.confirm('Send this follow-up now?')) return;

      const $row = $current;
      const release = () => $button.prop('disabled', false);
      $button.prop('disabled', true);
      saveIfDirty(() => post(String($row.data('send-url')), {}, () => window.location.reload(), release), release);
    })
    .on('click.todoApproval', '.todo-approval-skip', () => {
      if (!$current) return;
      // "Skip this one" is the label the handoff specifies, but the action cancels the follow-up for
      // good. Name the consequence and the non-destructive alternative here, where the decision is
      // actually made.
      if (!window.confirm("Skipping cancels this follow-up — it won't be sent at all. Use Reschedule to send it later instead. Continue?")) return;

      post(String($current.data('cancel-url')), {}, () => window.location.reload());
    })
    .on('click.todoApproval', '.todo-approval-push', function () {
      if (!$current) return;
      const $row = $current;
      openPicker($(this), (date) => reschedule($row, date, closeModal));
    });

  // Click the backdrop (but not the dialog) to dismiss.
  $modal.off('click.todoApprovalBackdrop').on('click.todoApprovalBackdrop', function (e) {
    if (e.target === this) closeModal();
  });

  // Escape closes the modal only, and only when it is the topmost surface — the reply drawer and the
  // candidate drawer bind Escape too.
  $(document)
    .off('keydown.todoApproval')
    .on('keydown.todoApproval', (e) => {
      if (e.key !== 'Escape') return;
      if ($modal.prop('hidden')) return;
      if ($('#candidate-drawer').hasClass('open')) return;

      e.stopPropagation();
      closeModal();
    });
}

export function initTodo(): void {
  if (!$('.todo-page').length) return;

  initSegmentFilter();
  initLoadMore();
  initApproval();
  initCallTasks();
  initCsTasks();
  openRequestedTab();
}
